// Import Angular Common Components/Module
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule, LOCALE_ID  } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { HttpModule } from '@angular/http'; // ← ADICIONE ESTA LINHA
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppComponent } from './app.component';

// import { AppSharedModule } from './components';
const ANGULAR_MODULES = [
    CommonModule, 
    RouterModule, 
    FormsModule, 
    ReactiveFormsModule, 
    HttpModule,           // ← ADICIONE ESTA LINHA AQUI TAMBÉM
    HttpClientModule, 
    HttpClientJsonpModule, 
    BrowserModule, 
    BrowserAnimationsModule
];

// Import containers
import { FullLayout, SimpleLayout } from './containers';

const APP_CONTAINERS = [FullLayout, SimpleLayout];

// Import components
import { AppBreadcrumbs } from './components/app-breadcrumbs';
import { AppFooter } from './components/app-footer';
import { AppHeader } from './components/app-header';
import { AppSidebar } from './components/app-sidebar';

const APP_COMPONENTS = [AppBreadcrumbs, AppFooter, AppHeader, AppSidebar];

// Import directives
import { NAV_DROPDOWN_DIRECTIVES, SIDEBAR_TOGGLE_DIRECTIVES } from './directives';

const APP_DIRECTIVES = [NAV_DROPDOWN_DIRECTIVES, SIDEBAR_TOGGLE_DIRECTIVES];

// componentes de autenticação
import { AutenticacaoService, AuthGuard, SGAAuthInterceptor, CustomOption, FornecedorService } from './services';
import { JwtDecoderService } from './services/jwt-decoder.service';

const APP_AUTH = [
    AutenticacaoService, 
    AuthGuard, 
    JwtDecoderService
];

// Import routing module
import { AppRoutingModule } from './app.routing';

// Import 3rd party components (ngx Modules)
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { PaginationModule } from 'ngx-bootstrap';
import { ChartsModule } from 'ng2-charts/ng2-charts';
import { ToastModule, ToastOptions } from 'ng2-toastr/ng2-toastr';

// DATEPICKER
import { defineLocale } from 'ngx-bootstrap';
import { ptBrLocale } from 'ngx-bootstrap/locale';
defineLocale('pt-br', ptBrLocale);

@NgModule({
    imports: [
        ...ANGULAR_MODULES,
        AppRoutingModule,
        ChartsModule,
        BsDropdownModule.forRoot(),
        TabsModule.forRoot(),
        TooltipModule.forRoot(),
        TypeaheadModule.forRoot(),
        ToastModule.forRoot(),
        PaginationModule.forRoot(),
    ],
    declarations: [
        AppComponent,
        ...APP_CONTAINERS,
        ...APP_COMPONENTS,
        ...APP_DIRECTIVES,
    ],
    providers: [
        ...APP_AUTH,
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        { provide: HTTP_INTERCEPTORS, useClass: SGAAuthInterceptor, multi: true },
        { provide: ToastOptions, useClass: CustomOption },
        { provide: LOCALE_ID, useValue: 'pt-BR' },
        FornecedorService,
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }


// WEBPACK FOOTER //
// /app/src/app/app.module.ts